import React from "react";
import CommonDocumentModuleInterface from "@/pages/T4/CommonDocumentModuleInterface";
import { useParams } from "react-router-dom";

interface T3ApprovalListProps {}

const T3ApprovalList: React.FC<T3ApprovalListProps> = () => {
  const { id } = useParams();
  return (
    <>
      <CommonDocumentModuleInterface isView={true} userId={id} />
    </>
  );
};

export default T3ApprovalList;
